export const githubEvents = `
subscription GitHubEvents($owner: String!, $repo: String!) {
  githubEvents(owner: $owner, repo: $repo) {
    ... on InstallationEvent {
      event
      action
    }
  }
}
`;

export interface GitHubEvents {
  githubEvents: {
    action: "CREATED";
    event: "installation";
  };
}
